import { Typography, styled } from '@mui/material'

const SubtitleGrey = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500]
}))

export default SubtitleGrey
